/**
 * * v4: Update for Remove empty paragraph from organizations and roles to make it editor stable
 * * The structure is changed according to the current version updateVersion props.
 */
export default (params) => {
  const { fieldType, fieldData, updateVersion } = params;

  const {
    document: { nodes: documentNodes },
  } = fieldData;

  const filteredOrganizations = documentNodes.filter(
    ({ type }) => type !== 'empty_paragraph',
  );

  let updatedRoleNodes = [];
  filteredOrganizations.forEach((organizationNodes) => {
    const { nodes: roleNodes } = organizationNodes;
    const filteredRoleNode = roleNodes.filter(
      ({ type }) => type !== 'empty_paragraph',
    );

    const updatedRole = {
      ...organizationNodes,
      nodes: filteredRoleNode,
    };
    updatedRoleNodes = [...updatedRoleNodes, updatedRole];
  });

  const updatedOrganizations = {
    ...fieldData,
    document: {
      ...fieldData.document,
      data: {
        ...fieldData.document.data,
        version: {
          number: updateVersion,
          updated: true,
        },
      },
      nodes: updatedRoleNodes,
    },
  };

  return { [fieldType]: updatedOrganizations };
};
